<script>
import { mapActions, mapState } from "vuex";
import cryptoRandomString from "crypto-random-string";
import compUmat from "@/components/form/umat";
import compUmatKomuni from "@/components/form/komuni";
import compUmatBaptis from "@/components/form/baptis";
import compUmatKrisma from "@/components/form/krisma";
import umatOpt from "@/data/umatOpt";

export default {
	name: "umatForm",
	components: {
		"comp-umat": compUmat,
		"comp-umat-komuni": compUmatKomuni,
		"comp-umat-baptis": compUmatBaptis,
		"comp-umat-krisma": compUmatKrisma,
	},
	data() {
		return {
			mode: "INSERT",
			uid: "",
			myOptions: {
				kriteria: umatOpt.kriteria,
				jk: umatOpt.jk,
				gol_darah: umatOpt.golDarah,
			},
			trigger: {
				umat: 0,
				baptis: 0,
				komuni: 0,
				krisma: 0,
			},
			checklist: {
				umat: true,
				baptis: false,
				komuni: false,
				krisma: false,
			},
		};
	},
	computed: {
		...mapState({
			umatItem: (state) => state.umat.item,
			umatBaptisItem: (state) => state.umatBaptis.item,
			umatKomuniItem: (state) => state.umatKomuni.item,
			// umatkrismaItem: (state) => state.umatKrisma.item,
		}),
		isLoading() {
			return this.$store.state.isLoading;
		},
		umatkrismaItem() {
			return this.$store.state.umatKrisma.item;
		},
	},
	watch: {
		isLoading: function (val) {
			if (val) {
				this.$swal({ text: "Loading", allowOutsideClick: false });
				this.$swal.showLoading();
			} else {
				this.$swal.close();
			}
		},
	},
	created() {
		this.$store.dispatch("umat/resetItem");
		this.$store.dispatch("umatBaptis/resetItem");
		this.$store.dispatch("umatKomuni/resetItem");
		this.$store.dispatch("umatKrisma/resetItem");
		this.getLingkunganStasi();
	},
	mounted() {
		this.uid = cryptoRandomString({
			length: 32,
			type: "distinguishable",
		});

		if (typeof this.$route.params.id !== "undefined") {
			this.mode = "UPDATE";

			this.getItemUmat(this.$route.params.id).then(
				(res) => {
					const _uid = res.data.umat.uid;
               
					this.setItemUmat(res.data.umat);
					this.setItemBaptis(res.data.baptis).then(() => {
						this.umatBaptisItem.uid = _uid;
					});
					this.setItemKomuni(res.data.komuni).then(() => {
						this.umatKomuniItem.uid = _uid;
					});
					this.setItemKrisma(res.data.krisma).then(() => {
						this.umatkrismaItem.uid = _uid;
					});

					this.checklist.baptis = res.data.umat.is_baptis ? true : false;
					this.checklist.komuni = res.data.umat.is_komuni ? true : false;
					this.checklist.krisma = res.data.umat.is_krisma ? true : false;
				},
				() => {
					this.$router.push("/umat");
				}
			);
		} else {
			this.umatItem.uid = this.uid;
			this.umatBaptisItem.uid = this.uid;
			this.umatKomuniItem.uid = this.uid;
			this.umatkrismaItem.uid = this.uid;
		}
	},
	methods: {
		...mapActions({
			insert: "umat/insert",
			update: "umat/update",

			setItemBaptis: "umatBaptis/setItem",
			setItemKomuni: "umatKomuni/setItem",
			setItemKrisma: "umatKrisma/setItem",

			setItemUmat: "umat/setItemForm",
			getItemUmat: "umat/getItem",
			getLingkunganStasi: "service/getLingkunganStasi",
		}),
		handleSumbmit() {
			this.trigger.umat = !this.trigger.umat;
		},
		async validateUmat(result) {
			await result.then((valid) => {
				if (!valid) {
					this.$toast.error("Identitas Umat belum lengkap");
				} else {
					this.trigger.baptis = !this.trigger.baptis;
				}
			});
		},
		async validateBaptis(result) {
			if (this.checklist.baptis) {
				await result.then((valid) => {
					if (!valid) {
						this.$toast.error("Data Baptis belum lengkap");
					} else {
						this.trigger.komuni = !this.trigger.komuni;
					}
				});
			} else {
				this.trigger.komuni = !this.trigger.komuni;
			}
		},
		async validateKomuni(result) {
			if (this.checklist.komuni) {
				await result.then((valid) => {
					if (!valid) {
						this.$toast.error("Data Komuni belum lengkap");
					} else {
						this.trigger.krisma = !this.trigger.krisma;
					}
				});
			} else {
				this.trigger.krisma = !this.trigger.krisma;
			}
		},
		async validateKrisma(result) {
			if (this.checklist.krisma) {
				await result.then((valid) => {
					if (!valid) {
						this.$toast.error("Data Krisma belum lengkap");
					} else {
						this.onSubmit();
					}
				});
			} else {
				this.onSubmit();
			}
		},
		onSubmit() {
			const data = {
				umat: this.umatItem,
				baptis: this.umatBaptisItem,
				komuni: this.umatKomuniItem,
				krisma: this.umatkrismaItem,
				checklist: this.checklist,
			};

			if (this.mode === "INSERT") {
				this.insert(data).then(() => {
					this.$router.push("/umat/detail/" + this.umatItem.uid);
				});
			} else {
				this.update(data).then(() => {
					this.$router.push("/umat/detail/" + this.umatItem.uid);
				});
			}
		},
		autoFill() {
			this.umatItem.nama = this.$faker().name.findName();
			this.umatItem.tempat_lahir = this.$faker().address.city();
			this.umatItem.alamat = this.$faker().address.streetName();
			this.umatItem.tgl_lahir = "2000-01-01";
			this.umatItem.jk = "L";
			this.umatItem.suku = "Dayak";
			this.umatItem.keuskupan = "Keuskupan Sintang";
			this.umatItem.paroki = "Paroki Kristus Raja Katedral Sintang";
			this.umatItem.lingkungan_stasi = "Stasi Jerora 1";
			this.umatItem.kabupaten = "Sintang";
			this.umatItem.kecamatan = "Sintang  ";
			this.umatItem.desa = "Jerora Satu";
			this.umatItem.agama = "Katolik";
			this.umatItem.pekerjaan = "Konsultan";
			this.umatItem.pendidikan = "S1";
			this.umatItem.jurusan = "Teknik Infomatika";
			this.umatItem.nik = "61287318273";
			this.umatItem.nohp = "081255225454";
			this.umatItem.email = "Dayak@gmail.com";
			this.umatItem.gol_darah = "O";
			this.umatItem.aktivitas = "Warga Biasa";
			this.umatItem.profesi = [{ text: "Guru", value: "Guru" }];
			this.umatItem.keterampilan = [{ text: "Musik", value: "Musik" }];
			this.umatItem.status_kawin = "Menikah";
			this.umatItem.cacat_tubuh = "Tidak";

			this.umatKomuniItem.no_buku = "12345";
			this.umatKomuniItem.no_lb = "54321";
			this.umatKomuniItem.tanggal = "2020-04-03";
			this.umatKomuniItem.keuskupan_lb = "Keuskupan Sintang";
			this.umatKomuniItem.paroki_lb = "Paroki Katedral Kristus Raja Sintang";
		},
		onBack() {
			this.$router.push("/umat");
		},
	},
};
</script>

<template>
	<div>
		<vue-fab
			mainBtnColor="#0071B3"
			:scrollAutoHide="false"
			size="big"
			:globalOptions="{ spacing: 50, delay: 0.05 }"
			icon="menu"
		>
			<fab-item
				@clickItem="handleSumbmit"
				:idx="0"
				title="Simpan"
				icon="save"
			/>
			<!-- <fab-item
				@clickItem="autoFill"
				:idx="1"
				title="Auto Fill"
				icon="input"
			/> -->
		</vue-fab>

		<Breadcrumbs main="Umat" title="Form Umat" />
		<!-- Container-fluid starts-->
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<form
						@submit.stop.prevent="onSubmit"
						v-if="isLoading"
						id="form-data"
					></form>
					<div class="card">
						<div class="card-header">
							<div class="row">
								<div class="col-sm-6">
									<h5 class="text-muted">Identitas Umat :</h5>
								</div>
								<div class="col-sm-6">
									<div class="text-right">
										<b-button-group class="btn-group-pill">
											<b-button
												variant="primary"
												size="sm"
												@click="onBack()"
												v-b-tooltip.hover
												title="Kembali"
												><i class="fa fa-arrow-left"></i> &nbsp;
												&nbsp;Kembali</b-button
											>
										</b-button-group>
									</div>
								</div>
							</div>
						</div>
						<br />
						<div class="card-body">
							<comp-umat
								@validate="validateUmat"
								:triggerValidation="trigger.umat"
							></comp-umat>
						</div>
					</div>
					<px-card>
						<div slot="with-padding">
							<div class="row">
								<div class="col-md-6">
									<h5 class="text-muted">Data Baptis :</h5>
								</div>
								<div class="col-md-6">
									<div class="media">
										<div
											class="
												media-body
												text-right
												icon-state
												switch-outline
											"
										>
											<label class="switch">
												<input
													type="checkbox"
													v-model="checklist.baptis"
												/><span
													class="switch-state bg-primary"
												></span>
											</label>
										</div>
									</div>
								</div>
							</div>

							<hr />

							<comp-umat-baptis
								v-show="checklist.baptis"
								@validate="validateBaptis"
								:triggerValidation="trigger.baptis"
							></comp-umat-baptis>
						</div>
					</px-card>

					<px-card>
						<div slot="with-padding">
							<div class="row">
								<div class="col-md-6">
									<h5 class="text-muted">Data Komuni I :</h5>
								</div>
								<div class="col-md-6">
									<div class="media">
										<div
											class="
												media-body
												text-right
												icon-state
												switch-outline
											"
										>
											<label class="switch">
												<input
													type="checkbox"
													v-model="checklist.komuni"
												/><span
													class="switch-state bg-primary"
												></span>
											</label>
										</div>
									</div>
								</div>
							</div>
							<hr />
							<comp-umat-komuni
								v-show="checklist.komuni"
								@validate="validateKomuni"
								:triggerValidation="trigger.komuni"
							></comp-umat-komuni>
						</div>
					</px-card>

					<px-card>
						<div slot="with-padding">
							<div class="row">
								<div class="col-md-6">
									<h5 class="text-muted">Data Krisma :</h5>
								</div>
								<div class="col-md-6">
									<div class="media">
										<div
											class="
												media-body
												text-right
												icon-state
												switch-outline
											"
										>
											<label class="switch">
												<input
													type="checkbox"
													v-model="checklist.krisma"
												/><span
													class="switch-state bg-primary"
												></span>
											</label>
										</div>
									</div>
								</div>
							</div>
							<hr />
							<comp-umat-krisma
								v-show="checklist.krisma"
								@validate="validateKrisma"
								:triggerValidation="trigger.krisma"
							></comp-umat-krisma>
						</div>
					</px-card>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.myModal {
	padding: 20px;
	scroll-behavior: smooth;
}
::v-deep .vm--modal {
	overflow-y: auto;
}
.modal-card {
	margin: 0px;
}
</style>